import Loading from '../components/Loading';
import React from 'react';
import authorize from '../actions/authorize';

export class AuthorizeRoute extends React.PureComponent {
    state = {
        error: undefined,
    };

    async componentDidMount() {
        try {
            await authorize();
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    render() {
        const { error } = this.state;
        if (error) {
            throw error;
        }

        return <Loading />;
    }
}

export default AuthorizeRoute;
